var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hb-btn',{attrs:{"icon":"","tooltip":"Help","target":"_blank","active-state-off":"","hover-background-color":_vm.bladeHeader ? '#CAEAEA' : ''},on:{"click":_vm.getHelpLink}},[_vm._v(" mdi-help-circle-outline ")])
}
var staticRenderFns = []

export { render, staticRenderFns }